import * as React from "react";
import styled from "styled-components";

import ToolbarDivider from "./ToolbarDivider";
import ToolbarButton from "./ToolbarButton";

import { Palette, ToolbarItemsPropTypes } from "../../vars";

class Toolbar extends React.Component<any, any> {
  static propTypes = {
    items: ToolbarItemsPropTypes.toolbarItems
  };

  renderToolbarButtons = items =>
    items.map((item, index) => (
      <ToolbarButton href={item.href} icon={item.icon} key={index + item.text}>
        {item.text}
      </ToolbarButton>
    ));

  render() {
    const { items, className } = this.props;

    const toolbarButtons = this.renderToolbarButtons(items);

    return (
      <div className={className}>
        <ToolbarDivider />
        {toolbarButtons}
      </div>
    );
  }
}

export default styled(Toolbar)`
  text-align: center;
  border-bottom: 1px solid ${Palette.TOOLBAR_ITEM_DIVIDER};

  display: flex;
  align-items: center;
  justify-content: flex-end;
`;
